import { Storage } from '@core/types';

export const sessionKeys = {
  sites: process.env.REACT_APP_SITES_KEY || '',
  products: process.env.REACT_APP_PRODUCTS_KEY || '',
  translations: process.env.REACT_APP_TRANSLATIONS_KEY || '',
  infoPopup: process.env.REACT_APP_INFO_POPUP_KEY || '',
};

class SessionStorage implements Storage.IStorage {
  /**
   * Gets a value using the given key from session storage
   * @param {string} key
   * @returns undefined if not found
   */
  get<T>(key: string): T | undefined {
    const value = sessionStorage.getItem(key);

    if (value === null || value === undefined) {
      return undefined;
    }

    return JSON.parse(value) as T;
  }

  /**
   * Sets a value in session storage.
   * @param {string} key
   * @param {*} value
   */
  set(key: string, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  /**
   * Removes an item from session storage
   * @param key key
   */
  delete(key: string) {
    sessionStorage.removeItem(key);
  }
}

export default new SessionStorage();
